











































































import { Component, Vue, Prop} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../lib/ajax';
import AbpBase from '../../../lib/abpbase';
import Appconst from '../../../lib/appconst';
@Component({
    name:'personnel'
})
export default class Personnel extends AbpBase  {
    initData:any = {
        searchData: {},
        fileUrl: Appconst.fileUrl,
        defaultFileList:[],
        modelTitle: '新增名号人才',
        tableData: {
            totalCount: 0,
            loading: true,
            title: [
                {
                    title: '序号',
                    key: 'achieveCode',
                    align: 'center',
                    width: 120
                },   
                {
                    title: '姓名',
                    key: 'author',
                    align: 'center',
                },
                {
                    title: '名号名称',
                    key: 'nametalentName',
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'text'
                                },
                                style: {
                                    color: '#57a3f3',
                                    cursor: 'pointer'
                                },
                                on: {
                                    click: () => {
                                        this.ShowModal('detail', params.row);
                                    }
                                }
                            }, params.row.nametalentName)
                        ])
                    }
                },
                {
                    title: '授予机构',
                    key: 'awardingInstitution',
                    align: 'center'
                },                    
                {
                    title: '授予时间',
                    key: 'awardingDt',
                    align: 'center',
                    render: (h:any, params:any)=>{
                        let awardingDt = new Date(params.row.awardingDt);
                        return h('Row', [
                            h('Col', {}, params.row.awardingDt ? awardingDt.getFullYear()+'年'+(awardingDt.getMonth()+1)+'月' : '/')
                        ])
                    }
                },
                {
                    title: '操作',
                    align: 'center',
                    render: (h:any, params:any) => {
                        return h('span', [
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                style: {
                                    display: params.row.canEdit?'':'none'
                                },
                                on: {
                                    click: () => {
                                        this.ShowModal('edit', params.row);
                                        this.initData.modelTitle = '编辑名号人才';
                                    }
                                }
                            }, '编辑'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginLeft: '20px',
                                    display: params.row.canDelete?'':'none'
                                },
                                on: {
                                    click: () => {
                                        this.Delete(params.row.id);
                                    }
                                }
                            }, '删除')
                        ])
                    }
                }
            ],
            content: []
        },
        modalData: {
            status: false,
            btnSatus: true,
            loading: true,
            content: {
                applyAmount: null,
                attachs:[]
            }
        }
    }
    //临时文件上传成功回调
    UploadSuccess(res:any, file:any, fileList:any) {
        this.initData.modalData.content.attachs.push(res.result);
    }
    //删除文件
    async DeleteFile(res:any) {
        if(res.id){
            //已有文件
            let data:any = {
                id: res.id
            }
            await Ajax.delete('/api/services/app/Achieve/DeleteAttachAsync', {params: data});
            this.GetData();
        }else{
            //临时文件
            await Ajax.post('/api/File/DeleteTempFile?filename='+res.response.result);
            this.initData.defaultFileList.splice(this.initData.formData.attachs.indexOf(res.response.result), 1);
        }
    }
    //获取列表数据
    async GetData() {
        this.initData.tableData.loading = true;
        let temp = (await Ajax.get('/api/services/app/Achieve/GetTechTalentByPageAsync', {params: this.initData.searchData})).data.result;
        this.initData.tableData.content = temp.items;
        this.initData.tableData.totalCount = temp.totalCount;
        if(this.initData.tableData.content.length == 0){
            this.$Message.error('暂无数据！') 
        }
        this.initData.tableData.loading = false;
    }
    //弹窗
    ShowModal(type:any, data:any) {
        (this as any).$refs.addForm.resetFields();
        if(type == 'add'){
            this.initData.modelTitle = '新增名号人才';
            this.initData.modalData.type = 'add';
            this.initData.modalData.content = {
                attachs:[]
            };
            this.initData.defaultFileList = [];
            this.initData.modalData.content.attachs = [];
        }else{  
            this.initData.modalData.content = Object.assign({},data);              
            this.initData.modalData.type = type;
            this.initData.modalData.content.id = data.id;
            this.initData.modalData.content.author = data.author;
            this.initData.modalData.content.nametalentName = data.nametalentName;
            this.initData.modalData.content.awardingInstitution = data.awardingInstitution;
            this.initData.modalData.content.awardingDt = new Date(data.awardingDt);
            this.initData.modalData.content.attachs = data.attachs;
            if(data.attachs) {
                this.initData.defaultFileList = data.attachs.map( (item:any) => {
                                                return {
                                                    name:item.attachName,
                                                    url:item.url,
                                                    id:item.id
                                                }
                                            } );
                
            } else {
                this.initData.defaultFileList = [];
            }
            if(this.initData.modalData.type != 'detail') {
                this.initData.modalData.content.attachs = [];
            }
            if(this.initData.modalData.type == 'detail') {
                this.initData.modelTitle = '名号人才详情';
            }
        }
        this.initData.modalData.loading = false;
        this.initData.modalData.status = true;
    }
    //新增
    async Add() {
        (this as any).$refs.addForm.validate(async (valid:boolean)=>{
            if(valid){
                this.initData.modalData.btnSatus = true;
                if(this.initData.modalData.type == 'add'){
                    Ajax.post('/api/services/app/Achieve/CreateTechTalentAsync', this.initData.modalData.content).then(()=>{
                        this.$Message.success('新增成功!');
                        this.GetData();
                        this.initData.modalData.status = false;
                    }).catch( () => {            
                        setTimeout(() => {
                            this.initData.modalData.btnSatus = false;
                            this.$nextTick(() => {
                                this.initData.modalData.btnSatus = true;
                            });
                        }, 1000);
                    } )
                }else{
                    Ajax.put('/api/services/app/Achieve/UpdateTechTalentAsync', this.initData.modalData.content).then(()=>{
                        this.$Message.success('修改成功!');
                        this.GetData();
                        this.initData.modalData.status = false;
                    }).catch( () => {            
                        setTimeout(() => {
                            this.initData.modalData.btnSatus = false;
                            this.$nextTick(() => {
                                this.initData.modalData.btnSatus = true;
                            });
                        }, 1000);
                    } )
                }
            }else{                    
                setTimeout(() => {
                    this.initData.modalData.btnSatus = false;
                    this.$nextTick(() => {
                        this.initData.modalData.btnSatus = true;
                    });
                }, 1000);
            }
        })
    }
    //删除
    async Delete(id:any) {
        this.$Modal.confirm({
                title: '标题',
                content: '是否删除该条数据？删除后不可恢复！',
                onOk:async() => {
                    await Ajax.delete('/api/services/app/Achieve/DeleteAwardPrizeAsync?Id='+id);
                    this.$Message.success('删除成功!');
                    this.GetData(); 
                },
                okText: '确定',
                cancelText: '取消'
            });
                   
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchData.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchData.MaxResultCount = perPage;
        this.GetData()
    }
    //初始化
    mounted() {
        this.GetData();
    }
    Export() {
        (this as any).$root.Export(this.initData.searchData, '/api/ResearchFile/ExportAllTechTalentAsync', '名号人才', 'xlsx');
    }        
    //弹窗验证
    rules:any = {
        author: [{required: true, message: '请填写姓名', trigger: 'blur'}],
        nametalentName: [{required: true, message: '请填写名号名称', trigger: 'blur'}],
        awardingInstitution: [{required: true, message: '请填写授予机构', trigger: 'blur'}],
        awardingDt: [{required: true, type: 'date', message: '请选择授予时间', trigger: 'change'}],         
    }
}
